import React from 'react'
import styled from 'styled-components'
import { H, P, Wrapper } from '@farewill/ui'
import { COLOR, GTR, BREAKPOINT } from '@farewill/ui/tokens'
import { screenMin } from '@farewill/ui/helpers/responsive'

import { CLOUDINARY_ROOT_PATH } from '@farewill/ui/components/Image/constants'
import LinkButton from 'components/LinkButton'
import PreventOrphan from 'components/PreventOrphan'

const cloudinarySrc = (fileName: string, width: number): string =>
  `${CLOUDINARY_ROOT_PATH}/c_scale,f_auto,q_auto,w_${
    width * 2
  }/com-assets/lpa/${fileName}.png`

const LpaIllustration = ({
  className,
}: {
  className?: string
}): React.ReactElement => (
  <picture>
    <source
      media={`(min-width: ${BREAKPOINT.M}px)`}
      srcSet={cloudinarySrc('illustration-lpa-clipboard-964px', 964)}
    />
    <source
      media={`(min-width: ${BREAKPOINT.S}px)`}
      srcSet={cloudinarySrc('illustration-lpa-clipboard-768px', 768)}
    />
    <source
      media="(min-width: 480px)"
      srcSet={cloudinarySrc('illustration-lpa-clipboard-500px', 500)}
    />
    <img
      className={className}
      src={cloudinarySrc('illustration-lpa-clipboard-400px', 400)}
      alt=""
    />
  </picture>
)

const StyledWrapper = styled(Wrapper)`
  overflow: hidden;
  position: relative;

  ${screenMin.m`
    display: grid;
    grid-template-columns: 1fr 1fr;
  `}
`

const StyledContent = styled(Wrapper)`
  padding: ${GTR.M};

  ${screenMin.l`
    padding: ${GTR.XL} 0 ${GTR.XL} ${GTR.L};
  `}

  ${screenMin.xl`
    padding: ${GTR.XXL} 0 ${GTR.XXL} ${GTR.XL};
  `}
`

const StyledImageWrapper = styled(Wrapper)`
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;

  ${screenMin.m`
    justify-content: flex-end;
  `}
`

const StyledImage = styled(LpaIllustration)`
  width: 100%;
  margin-top: ${GTR.M};

  ${screenMin.m`
    max-width: 320px;
  `}
  ${screenMin.l`
    max-width: 520px;
  `}
`

const LpaCrossSell = (): React.ReactElement => (
  <Wrapper container>
    <StyledWrapper
      background={COLOR.ACCENT.PRIMARY_10}
      bordered
      borderRadius="S"
    >
      <StyledContent>
        <H size="M" margin={[0, 0, 'S']} decorative>
          Lasting power of attorney
        </H>
        <P margin={[0, 0, 'M']}>
          <PreventOrphan>
            Our specialists do the hard work for you, with your LPAs handled
            over the phone.
          </PreventOrphan>
        </P>
        <LinkButton to="/lasting-power-of-attorney">
          Get my LPA sorted
        </LinkButton>
      </StyledContent>
      <StyledImageWrapper>
        <StyledImage />
      </StyledImageWrapper>
    </StyledWrapper>
  </Wrapper>
)

export default LpaCrossSell
